module.exports = __webpack_public_path__ + "assets/c0926a9dc34f870829e9a9a7dd146547.png";